import {
    DependenciesPayload,
    PaymentMethod,
} from '@sxm-de/dev-kits/web-sdk/types';
import { getDefaultBillingProfile } from './get-default-billing-profile';
import {
    differenceInMonths,
    MapClientSdkToWebSdk,
} from '@sxm-de/dev-kits/web-sdk/utils';

export async function getDefaultPaymentMethod(
    dependenciesPayload: DependenciesPayload,
): Promise<PaymentMethod> {
    const { clientSdk, appEventSdk } = dependenciesPayload;
    try {
        const billingProfile =
            await getDefaultBillingProfile(dependenciesPayload);
        const billingProfileId = billingProfile.id;
        const paymentMethodId = billingProfile.defaultPaymentMethodId;

        const mapClientSdkToWebSdk: MapClientSdkToWebSdk<
            Awaited<
                ReturnType<typeof clientSdk.commerce.billing.getPaymentMethod>
            >,
            { paymentMethod: PaymentMethod }
        > = ({ paymentMethod }) => {
            return {
                paymentMethod: {
                    card: {
                        ...paymentMethod.card,
                        billingAddress: {
                            addressLine1:
                                paymentMethod.card.billingAddress
                                    ?.addressLine1 || '',
                            city: paymentMethod.card.billingAddress?.city || '',
                            state:
                                paymentMethod.card.billingAddress?.state || '',
                            zipCode:
                                paymentMethod.card.billingAddress?.zipCode ||
                                '',
                            country:
                                paymentMethod.card.billingAddress?.country ||
                                '',
                        },
                        last4: paymentMethod.card.last4,
                        /**
                         * Note:
                         * Looks like ClientSdk model does not contain the wallet property
                         */
                        wallet: (paymentMethod.card as any).wallet,
                    },
                },
            };
        };
        const { paymentMethod } = mapClientSdkToWebSdk(
            await clientSdk.commerce.billing.getPaymentMethod(
                billingProfileId,
                paymentMethodId,
            ),
        );
        appEventSdk.trackEvent({
            event: 'customer-info',
            customerInfo: {
                billingAddress: {
                    state: paymentMethod?.card?.billingAddress?.state,
                },
            },
        });

        return paymentMethod;
    } catch (error: any) {
        /**
         * TODO:
         * Log error to error logger (not analytics).
         */
        throw new Error('SYSTEM');
    }
}

export function getCardExpirationState(year: number, month: number) {
    const cardExpirationDate = new Date(year, month - 1);
    if (cardExpirationDate) {
        if (differenceInMonths(new Date(), cardExpirationDate) < 0) {
            //card already expired
            return 'EXPIRED';
        } else if (differenceInMonths(new Date(), cardExpirationDate) === 0) {
            //card will expire this month
            return 'SOON_EXPIRED';
        }
        return 'VALID';
    }
    return null;
}
